import { render, staticRenderFns } from "./ReceiversList.vue?vue&type=template&id=627d6f8a&scoped=true&"
import script from "./ReceiversList.vue?vue&type=script&lang=js&"
export * from "./ReceiversList.vue?vue&type=script&lang=js&"
import style0 from "./ReceiversList.vue?vue&type=style&index=0&id=627d6f8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627d6f8a",
  null
  
)

export default component.exports